import { Observable, of } from 'rxjs';
import { LogWriter } from 'common-components';
import { LogEntry } from 'common-components';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

export class BackendWriter implements LogWriter {

    constructor(private httpClient: HttpClient) {
    }

    public location = null;

    public clear(): Observable<boolean> {
        // eslint-disable-next-line
        console.clear();
        return of(true);
    }

    public log(entry: LogEntry): Observable<boolean> {
        if (entry) {
            this.httpClient.post(`${environment.apiBaseUri}/errors`, entry).subscribe();
        }
        return of(true);
    }
}
